module.exports = __webpack_public_path__ + "static/media/dr-virajinee-old.18e53f4c.jpg";